module.exports = __webpack_public_path__ + "img/start-fresh.678261e4.png";